export default "__VITE_ASSET__C0Y5K8iE__"